<template>
  <div
    class="h-full flex flex-col relative overflow-hidden"
    ref="pageContainer"
  >
    <div
      class="fixed pointer-events-none deco w-full h-full rounded-content-md opacity-50"
    >
      <div
        class="fixed w-full h-full"
        style="
          background: linear-gradient(170.76deg, #37b6e9 6.44%, #4b4ced 99.29%);
          clip-path: polygon(80% 25%, 100% 34%, 100% 100%, 0% 100%);
        "
      ></div>
    </div>
    <div class="flex justify-between items-center p-6 pb-0 sticky">
      <div class="top-0 text-3xl font-bold relative">
        <div
          class="w-8 top-0 right-0 absolute translate-x-2/3 -translate-y-1/2"
        >
          <img
            src="@/assets/images/king-recharge-assets/crown-white.svg"
            class="w-full"
            alt=""
          />
        </div>
        <div>King Recharge</div>
      </div>
      <div class="flex gap-4" v-if="false">
        <router-link
          to="/subscriptions"
          class="w-10 h-10 ripple flex justify-center items-center"
          id="affiliation_button"
        >
          <img
            src="~@/assets/images/all/features.png"
            alt=""
            class="w-full h-full"
          />
        </router-link>

        <button
          class="w-10 h-10 ripple flex justify-center items-center"
          id="affiliation_button"
          @click="$Events.dispatchEvent('affiliation_share_requested')"
        >
          <LottieComponent
            content="gift"
            loop
            class="w-[70px] h-[70px] min-w-[70px] min-h-[70px] -mt-2"
            animationDuration="10000"
          />
          <!-- <img
              src="~@/assets/images/all/bonus-black.svg"
              alt=""
              class="w-full h-full"
            /> -->
        </button>
      </div>
    </div>
    <div class="relative z-[1] h-[calc(100%-40px)] -mb-7">
      <SubscriptionList />
    </div>
    <!-- <div class="sticky bottom-0 z-[1]">
      <HomeBottomNavs />
    </div> -->
    <HelpButtons />
  </div>
</template>

<script>
// import HomeBottomNavs from '@/components/mobile/appComponent/HomeBottomNavs.vue'
// import LottieComponent from '@/components/utils/LottieComponent.vue'
// import HomeTabs from '../appComponent/HomeTabs.vue'
// import HelpButtons from '../../appComponent/HelpButtons.vue'
import SubscriptionList from "@/components/transaction/SubscriptionList.vue"

export default {
  // name: 'home',
  components: {SubscriptionList
    // HomeBottomNavs,
    // LottieComponent,
    // HomeTabs,
    // HelpButtons,
  },
  data() {
    return {
      eventsIds: [],
      activeTab: 'home',
    }
  },
  beforeUnmount() {
  },
  mounted() {
  },
  methods: {
  },
}
</script>
